// extracted by mini-css-extract-plugin
module.exports = {"ware-field":"Qc_3DFEutk","normal-image":"_6mHZCyDy0H","ware-subtitle":"i_d3dbXiJ_","ware-price-text":"og9W5zBZkU","time-class":"_19YGo9STpS"};